import { Platform } from '@angular/cdk/platform';

export class ElPlatform extends Platform {}
